import { render, staticRenderFns } from "./Besuchsbericht.vue?vue&type=template&id=773867fe&scoped=true"
import script from "./Besuchsbericht.vue?vue&type=script&lang=js"
export * from "./Besuchsbericht.vue?vue&type=script&lang=js"
import style0 from "./Besuchsbericht.vue?vue&type=style&index=0&id=773867fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773867fe",
  null
  
)

export default component.exports